<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <TeamHideServicesTable
          ref="hideServicesTable"
          :account-id="$route.params.accountId"
          :team-id="$route.params.teamId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TeamHideServicesTable from '@/components/Application/Manage/Account/TeamHideServicesTable'

export default {
  components: {
    TeamHideServicesTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Hidden Services',
        route: { name: 'manage-accounts-account-configurations-teams-team-hideservices', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } }
      }
    }
  },
  mounted () {
    this.actions = this.$refs.hideServicesTable.actions
  }
}
</script>

<style>

</style>
